export class WebGL {
    constructor(gl) {
        this.gl = gl;
    }


    // Utility to complain loudly if we fail to find the uniform
    getUniformLocation(program, name) {
        const gl = this.gl;

        var uniformLocation = gl.getUniformLocation(program, name);
        if (uniformLocation === -1) {
            throw 'Can not find uniform ' + name + '.';
        }
        return uniformLocation;
    }




    // Utility to complain loudly if we fail to find the attribute
    getAttribLocation(program, name) {
        const gl = this.gl;

        const attributeLocation = gl.getAttribLocation(program, name);
        if (attributeLocation === -1) {
            throw 'Can not find attribute ' + name + '.';
        }
        return attributeLocation;
    }

    // Utility to fail loudly on shader compilation failure
    compileShader(shaderSource, shaderType) {
        const gl = this.gl;

        var shader = gl.createShader(shaderType);
        gl.shaderSource(shader, shaderSource);
        gl.compileShader(shader);

        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
            console.log(shaderSource);
            throw "Shader compile failed with: " + gl.getShaderInfoLog(shader);
        }

        return shader;
    }

}
